import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCommonColors } from "octalog-base";

import { QUERY_KEY_CONTACTS } from "../../common/Constants";
import { tryToExtractDescription } from "../../common/error/ErrorMessageUtil";
import { createContactMutation } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const useCreateContactMutation = () => {
  const commonColors = useCommonColors();
  const queryClient = useQueryClient();
  return useMutation({
    ...createContactMutation(),
    onSuccess: () => {
      // noinspection JSIgnoredPromiseFromCall
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY_CONTACTS,
      });
      notifications.show({
        title: "Erfolg",
        message: `Kontakt wurde erfolgreich erstellt!`,
        color: commonColors.greenPrimary,
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Fehler",
        message: `Kontakt konnte nicht erstellt werden: ${tryToExtractDescription(error)}`,
        color: commonColors.redPrimary,
      });
    },
  });
};
